import { render, staticRenderFns } from "./TransactionsInfoModal.vue?vue&type=template&id=34108f66"
import script from "./TransactionsInfoModal.vue?vue&type=script&lang=ts"
export * from "./TransactionsInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports